import { RouterProvider } from 'react-router-dom';

import { useAppRouter } from '@/common/hooks/useAppRouter';

export function AppRoutes() {
  const { activeRouter } = useAppRouter();

  return <RouterProvider router={activeRouter} />;
}
